<template lang="pug">
  v-expansion-panel.ld-summary-list(v-model="openPanels" expand)
    v-expansion-panel-content(
      v-for="(item, i) in items"
      :key="i"
      :disabled="true"
      :class="{ 'has-content': item.text }"
    )
      //- :disabled Required for visual purposes and not mislead users
      div.headline(slot="header") {{ item.header }}
      v-card-text.pa-0
        v-layout
          v-flex.text-truncate(xs9)
            v-icon.pr-2 {{ item.icon }}
            | {{ item.text }}
          v-flex(xs3)
            v-btn.float-right.ma-0.py-0.px-1.liondesk-panel-button(
              flat
              @click="emitSelection(item.key)"
              :disabled="editDisabled"
            ) Edit
</template>
<script>
export default {
  data() {
    return {
      /**
       * The truthy values of the props.items.
       * This controls which lists are expanded
       */
      openPanels: [],
    };
  },
  props: {
    /**
     * Controls whether the edit button is disabled or not
     */
    editDisabled: Boolean,
    /**
     * The initial items we want to populate the expander with
     * It expects an array of objects in the following format:
     * {
     *    header: 'This is a header!', // String
     *    text: 'This is the content!', // String
     *    icon: 'email', // String, The prepended icon
     * }
     */
    items: Array,
    /**
     * The v-model bound to the callback if the `edit` button
     * is clicked, indicating which stage the user is on right now.
     */
    value: String,
  },
  mounted() {
    this.checkExpansion(this.items);
  },
  watch: {
    items: {
      handler(value) {
        this.checkExpansion(value);
      },
      deep: true,
    },
  },
  methods: {
    /**
     * Generates an array of booleans, which is true if it has content
     * Otherwise, input false.
     */
    checkExpansion(items) {
      const openPanels = [];
      if (items && items.length) {
        items.forEach(item => {
          // Push true if content is present
          openPanels.push(!!item.text);
        });
        this.openPanels = openPanels;
      }
    },
    /**
     * Emits the index at which the item is located
     */
    emitSelection(index) {
      this.$emit('input', index);
    },
  },
};
</script>
<style lang="scss">
// Aruably this could be in the 'liondesk.scss' file, but in light of encapsulation,
// it might be better to write this here so that this component be modular
.ld-summary-list {
  box-shadow: none;
  .v-expansion-panel__header {
    padding: 30px 0 10px 0;
  } // Controls the padding for child components
  .has-content {
    color: var(--v-primary-base) !important;
    font-size: 20px;
  }
  .v-expansion-panel__body {
    font-size: 15px;
    color: var(--v-background-lighten1);
    padding-bottom: 10px;
  } // Formats the body if exists
  li {
    background: none !important;
  }
  li:last-child {
    border-bottom: 1px solid rgba(0,0,0,0.12);
  } // Required because box-shadow none removes bottom border
  button {
    height: inherit;
  }

  .liondesk-panel-button {
    min-width: 30px;
    color: var(--v-primary-lighten1);
  }
}
</style>
